import { Controller } from "@hotwired/stimulus"
import { showBlock } from "lib/helpers"

// Profile tab controller for _edit_profile partial.
// Handles avatar upload/remove and the /command input sanitizer.
export default class extends Controller {
  static values = {
    errorBlock: { type: String, default: "#chatbot-errors" },
  }

  connect() {
    this.initUploadImgHandler('avatar')
    this.initUploadImgHover('avatar')
    this.initTypeCommandHandler()
  }

  initUploadImgHandler(entity) {
    const self = this
    $("input." + entity + "-input").on('change.editProfile', function () {
      if (this.disabled) { showBlock(self.errorBlockValue, "File upload not supported!"); return }
      if (this.files && this.files[0]) self.readImage(this.files[0], entity)
    })
  }

  readImage(file, entity) {
    const fileInput = $("input." + entity + "-input")
    const uploadedImage = $('.' + entity + '-uploaded-image')
    const currentImg = $('img#current-' + entity)
    const action = $('.' + entity + '-action')
    const targetImg = $('img.' + entity)
    const targetImgWrapper = $('.' + entity + '-wrapper')
    const errorBlock = this.errorBlockValue

    if (file.size > 1048576) { showBlock(errorBlock, "Image is too large (current: " + file.size + " Byte, max: 1MB (1048576)"); fileInput.val(""); return }
    if (file.size < 100) { showBlock(errorBlock, "Image is too small (current: " + file.size + " Byte, min: 100 Bytes"); fileInput.val(""); return }

    const reader = new FileReader()
    const image = new Image()
    const self = this
    reader.readAsDataURL(file)
    reader.onload = function (_file) {
      image.src = _file.target.result
      image.onload = function () {
        uploadedImage.removeClass('hide')
        currentImg.attr('src', this.src)
        if (targetImg.length > 0) targetImg.attr('src', this.src)
        if (targetImgWrapper.length > 0) targetImgWrapper[0].dataset.buttonLogoUrl = this.src
        action.val('upload')
        self.initUploadImgHover(entity)
      }
      image.onerror = function () { showBlock(errorBlock, 'Invalid file type: ' + file.type); fileInput.val("") }
    }
  }

  initUploadImgHover(entity) {
    const self = this
    const reload = $('.reload-' + entity)
    $('.' + entity + '-uploaded-image').on("mouseenter.editProfile", function () {
      reload.removeClass('hide')
      $(this).off("mouseenter.editProfile")
      self.initRemoveAvatar(entity)
    })
  }

  initRemoveAvatar(entity) {
    const self = this
    $('.reload-' + entity).on("mouseleave.editProfile", function () {
      $(this).addClass('hide')
      $(this).off("mouseleave.editProfile click.editProfile")
      self.initUploadImgHover(entity)
    }).on("click.editProfile", function () {
      const uploadedImage = $('.' + entity + '-uploaded-image')
      const currentImg = $('img#current-' + entity)
      const fileInput = $("input." + entity + "-input")
      const action = $('.' + entity + '-action')
      const targetImg = $('img.' + entity)
      currentImg.attr('src', currentImg.data("default-url"))
      if (targetImg.length > 0) targetImg.attr('src', currentImg.data("default-url"))
      fileInput.val("")
      action.val('delete')
      $(this).off("mouseleave.editProfile click.editProfile")
      uploadedImage.off("mouseenter.editProfile")
      uploadedImage.addClass('hide')
      $(this).addClass('hide')
    })
  }

  initTypeCommandHandler() {
    let timeout
    $("#chat_assistant_command").on("input.editProfile", function () {
      clearTimeout(timeout)
      const el = $(this)
      timeout = setTimeout(() => {
        let value = el.val()
        const sanitized = value
          .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
          .replace(/javascript:/gi, '').replace(/on\w+\s*=/gi, '')
          .replace(/<iframe/gi, '').replace(/<object/gi, '').replace(/<embed/gi, '')
          .replace(/[<>"'&]/g, '')
        if (value !== sanitized) el.val(sanitized)
        $('.chatbot-command-example').html("/" + sanitized)
      }, 300)
    })
  }
}
